/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { StateCreator } from 'zustand';

import { User } from '@/client';

export type SelectedTenant = {
  id: string;
  name: string;
};

export interface UserProfileSlice {
  userProfile?: User;
  selectedTenantID?: string;
  selectedTenantName?: string;
  setProfile: (profile?: User) => void;
  setSelectedTenantID: (tenantID: string) => void;
  setSelectedTenant: (tenant: SelectedTenant) => void;
  clearSelectedTenant: () => void;
}

export const selectedTenantIDKey = 'selectedTenantID';
export const selectedTenantNameKey = 'selectedTenantName';

const selectedTenantID = localStorage.getItem(selectedTenantIDKey);
const selectedTenantName = localStorage.getItem(selectedTenantNameKey);

export const createUserProfileSlice: StateCreator<UserProfileSlice, [], [], UserProfileSlice> = (set) => ({
  userProfile: undefined,
  selectedTenantID: selectedTenantID || undefined,
  selectedTenantName: selectedTenantName || undefined,
  setProfile: (newProfile) =>
    set((userState) => {
      if (!userState.selectedTenantID) {
        return { userProfile: newProfile, selectedTenantID: newProfile?.tenantID };
      }
      return { userProfile: newProfile };
    }),
  setSelectedTenantID: (tenantID) =>
    set((state) => {
      localStorage.setItem(selectedTenantIDKey, tenantID);
      return { ...state, selectedTenantID: tenantID };
    }),
  setSelectedTenant: (tenant) =>
    set((state) => {
      localStorage.setItem(selectedTenantIDKey, tenant.id);
      localStorage.setItem(selectedTenantNameKey, tenant.name);
      return { ...state, selectedTenantID: tenant.id, selectedTenantName: tenant.name };
    }),
  clearSelectedTenant: () =>
    set((state) => {
      localStorage.removeItem(selectedTenantIDKey);
      localStorage.removeItem(selectedTenantNameKey);
      return { ...state, selectedTenantID: undefined, selectedTenantName: undefined };
    }),
});
